import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
import * as S from './styled';
//Components
import { useEffect } from 'react';
import LayoutModal from '../../../LayoutModal';
import Loading from "../../../Loading";
//hooks
import useLoading from "../../../../hooks/useLoading";
import apiRequest from '../../../../hooks/apiRequest';
//Interfaces
import { Inputs } from 'Interfaces/ICard';
import { NumericFormat } from 'react-number-format';

interface ICreate {
  isOpenModal: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
  updateList: () => void;
}

export default function Update({ isOpenModal, setModalClose, updateList, selectedUrlId }: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const response = await axiosInstance.get(`card/${selectedUrlId}`);
        const addressData = response.data;
        for (const key in addressData) {
          setValue(key as keyof Inputs, addressData[key]);
        }
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        stopLoading();
      }
    };
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);


  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(`card/${selectedUrlId}`, 'PATCH', data);
      if (response.status === 200) {
        alert("Taxa atualizada com sucesso!");
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Atualizar Taxa do Cartão"
        subTitle="Atualize informações da taxa em sua base de dados."
        setModalClose={setModalClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"

        nameIconMinimize={'Atualizar Fornecedor'}
      >
        {
          isLoading ? (
            <Loading />
          ) :
            <S.Container>
              <S.FormInput>
                <S.Label>
                  Parcelas
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Número de parcelas"
                  type="number"
                  {...register("number_installment", { required: true })}
                />
                {errors.number_installment && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>Taxa (%)</S.Label>
                <Controller
                  name="interest_rate"
                  control={control}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="0,00 %"
                      suffix=" %"
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue); // Atualiza o valor de compra
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
              </S.FormInput>
            </S.Container>
        }

      </LayoutModal>
    );
  }
  return null;
}